import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['regionToggle', 'countryCheckbox']

  connect() {
    this.syncAllRegions()
  }

  toggleRegion(event) {
    const region = event.currentTarget.dataset.region
    const checked = event.currentTarget.checked

    this.countryCheckboxTargets
      .filter((checkbox) => checkbox.dataset.region === region)
      .forEach((checkbox) => {
        checkbox.checked = checked
      })
  }

  syncRegion(event) {
    this.updateRegionToggle(event.currentTarget.dataset.region)
  }

  syncAllRegions() {
    this.regionToggleTargets.forEach((toggle) => {
      this.updateRegionToggle(toggle.dataset.region)
    })
  }

  updateRegionToggle(region) {
    const regionCheckboxes = this.countryCheckboxTargets.filter(
      (checkbox) => checkbox.dataset.region === region,
    )
    const regionToggle = this.regionToggleTargets.find(
      (toggle) => toggle.dataset.region === region,
    )

    if (!regionToggle || regionCheckboxes.length === 0) return

    regionToggle.checked = regionCheckboxes.every(
      (checkbox) => checkbox.checked,
    )
  }
}
